import React from 'react';
import { connect } from 'react-redux';
import {
  authCurrentDefaultTypeSelecetor,
  authCurrentUserSelector
} from '../../../modules/auth/Selectors';
import { Redirect, Route, Switch } from 'react-router-dom';
import users from '../users';
// Users
import artisans from '../artisans';
import suppliers from '../suppliers';
import customers from '../customers';

// Categories
import artisanCategories from '../artisanCategories';
import supplierCategories from '../supplierCategories';

// Job Categories
import artisanJobCategories from '../artisanJobCategories';
import supplierJobCategories from '../supplierJobCategories';

// Tags
import artisanTags from '../artisanTags';
import supplierTags from '../supplierTags';

// Products
import artisanProducts from '../artisanProducts';
import supplierProducts from '../supplierProducts';

// Moderations
import artisansModeration from '../artisansModeration';
import suppliersModeration from '../suppliersModeration';

import customersModeration from '../customersModeration';
import applicantsModeration from '../applicantsModeration';

//reports
import usersReports from '../reports/users';
import artisansReports from '../reports/artisans';
import suppliersReports from '../reports/suppliers';
import artisansTagsReports from '../reports/artisansTags';
import suppliersTagsReports from '../reports/suppliersTags';
import artisansCategoriesReports from '../reports/artisansCategories';
import suppliersCategoriesReports from '../reports/suppliersCategories';
//
import DashBoard from '../../../components/Dashboard/Dashboard';
import updateUser from '../users/UpdateUserForm';
// User Settings

import UserSettings from '../userSettings/';

import ArtisanProductList from '../myProductsList/Artisan';
import SupplierProductList from '../myProductsList/Supplier';

import ArtisanFollowerList from '../FollowerList/Artisan';
import SupplierFollowerList from '../FollowerList/Supplier';

import MyArtisanPrivateInquiries from '../myInquiries/Artisan/Private/index';

import myArtisanPrivateInquiriesList from '../myInquiries/Artisan/Private/';
import myArtisanPublicInquiriesList from '../myInquiries/Artisan/Public/';

import mySupplierPrivateInquiriesList from '../myInquiries/Supplier/Private/';
import mySupplierPublicInquiriesList from '../myInquiries/Supplier/Public/';

import customerArtisanFollowingList from '../customerFollowingList/Artisan/';
import customerSupplierFollowingList from '../customerFollowingList/Supplier';

// customer fav products
import CustomerFavArtisanProducts from '../customerFavArtisanProducts/';
import CustomerFavSupplierProducts from '../customerFavSupplierProducts/';
import FormEditIndex from '../users/CreateProfiles';
// customer private inquiry

import CustomerPrivateInquiries from '../customerPrivateInquiries/Artisan';
import CustomerPrivateSupplierInquiry from '../customerPrivateInquiries/Supplier';

// customer Public Inquiry

import customerPublicArtisanInquiry from '../customerPublicInquiries/Artisan';
import customerPublicSupplierInquiry from '../customerPublicInquiries/Supplier';
// import TrainingCenter from "../training center";
import trainingCenterList from '../TrainingCenter/';
import trainingCenterForm from '../TrainingCenter/TrainingCenterFrom';
import TrainingCenterCourseList from '../TrainingCenter/TrainingCenterCourseList';
import TrainingCenterCourseForm from '../TrainingCenter/TrainingCenterCourseForm';

import SuperAdminRoute from '../../router/SuperAdminRoute';
import AdminRoute from '../../router/AdminRoute';
import ArtisanRoute from '../../router/ArtisanRoute';
import SupplierRoute from '../../router/SupplierRoute';
import CustomerRoute from '../../router/CustomerRoute';
import AdminsRoute from '../../router/AdminsRoute';

// jobs

import supplierJobs from '../jobs/Supplier/index';
import companyJobs from '../jobs/company/index';
import ArtisanJobs from '../jobs/Artisan/index';
import applicantsjobs from '../jobs/Applicants/index';
import RecArtisanJobsList from '../jobs/Applicants/RecArtisanJobsList';
function HomePage(props) {
  const { userData, userType } = props;
  return (
    <Switch>
      <Redirect exact from='/' to='/dashboard' />

      {userType === '0' && <SuperAdminRoute path='/users' component={users} />}
      {userType === '1' && <AdminRoute path='/users' component={users} />}

      {/* Super Admin */}

      <Route path='/artisans' component={artisans} />
      <Route path='/suppliers' component={suppliers} />
      <Route path='/customers' component={customers} />
      <SuperAdminRoute
        path='/artisan-categories'
        component={artisanCategories}
      />
      <SuperAdminRoute
        path='/job/artisan-categories'
        component={artisanJobCategories}
      />

      <SuperAdminRoute
        path='/job/supplier-categories'
        component={supplierJobCategories}
      />
      <SuperAdminRoute
        path='/supplier-categories'
        component={supplierCategories}
      />
      <SuperAdminRoute path='/artisan-tags' component={artisanTags} />
      <SuperAdminRoute path='/supplier-tags' component={supplierTags} />

      <AdminsRoute
        exact
        path='/training-center/create'
        component={trainingCenterForm}
      />
      <AdminsRoute
        exact
        path='/training-center/:id'
        component={trainingCenterForm}
      />
      <AdminsRoute
        exact
        path='/training-center/:id/course'
        component={TrainingCenterCourseList}
      />
      <AdminsRoute
        exact
        path='/training-center/:id/course/create'
        component={TrainingCenterCourseForm}
      />
      <AdminsRoute
        exact
        path='/training-center/:id/course/:cid'
        component={TrainingCenterCourseForm}
      />

      {/* Admin */}
      <AdminRoute path='/users' component={users} />
      <AdminRoute path='/artisan-products' component={artisanProducts} />
      <AdminRoute path='/supplier-products' component={supplierProducts} />
      <Route path='/my-supplier-jobs' component={supplierJobs} />
      <AdminRoute path='/artisans-moderation' component={artisansModeration} />
      <AdminRoute
        path='/suppliers-moderation'
        component={suppliersModeration}
      />
      <AdminRoute
        path='/customers-moderation'
        component={customersModeration}
      />
      <AdminRoute
        path='/applicants-moderation'
        component={applicantsModeration}
      />

      {/* <AdminRoute
            exact
            path="/training-center/:id"
            component={trainingCenterForm}
          />
          <AdminRoute
            exact
            path="/training-center/:id/course"
            component={TrainingCenterCourseList}
          />
          <AdminRoute
            exact
            path="/training-center/:id/course/create"
            component={TrainingCenterCourseForm}
          />

          <AdminRoute
            exact
            path="/training-center/:id/course/:cid"
            component={TrainingCenterCourseForm}
          /> */}

      {/* Artisan */}
      <ArtisanRoute
        path='/my-artisan-products'
        component={ArtisanProductList}
      />
      <ArtisanRoute
        path='/my-artisan-followers'
        component={ArtisanFollowerList}
      />
      <ArtisanRoute
        path='/my-private-inquiries-artisan'
        component={myArtisanPrivateInquiriesList}
      />
      <ArtisanRoute
        path='/my-public-inquiries-artisan'
        component={myArtisanPublicInquiriesList}
      />

      {/* Customer */}
      <CustomerRoute
        path='/artisan-followings'
        component={customerArtisanFollowingList}
      />
      <CustomerRoute
        path='/supplier-followings'
        component={customerSupplierFollowingList}
      />
      {/* <Route path='/artisan-fav-products' 
        component={CustomerFavArtisanProducts}
        /> */}
      <CustomerRoute
        path='/artisan-fav-products'
        component={CustomerFavArtisanProducts}
      />
      <CustomerRoute
        path='/supplier-fav-products'
        component={CustomerFavSupplierProducts}
      />
      <CustomerRoute
        path='/customer-private-inquiry-artisan'
        component={CustomerPrivateInquiries}
      />
      <CustomerRoute
        path='/customer-private-inquiry-supplier'
        component={CustomerPrivateSupplierInquiry}
      />
      <CustomerRoute
        path='/customer-public-inquiry-artisan'
        component={customerPublicArtisanInquiry}
      />
      <CustomerRoute
        path='/customer-public-inquiry-supplier'
        component={customerPublicSupplierInquiry}
      />

      {/* Supplier */}
      <SupplierRoute
        path='/my-supplier-products'
        component={SupplierProductList}
      />
      <SupplierRoute
        path='/my-supplier-followers'
        component={SupplierFollowerList}
      />
      <SupplierRoute
        path='/my-private-inquiries-supplier'
        component={mySupplierPrivateInquiriesList}
      />
      <SupplierRoute
        path='/my-public-inquiries-supplier'
        component={mySupplierPublicInquiriesList}
      />
      <Route exact path='/training-center' component={trainingCenterList} />

      <Route path='/dashboard' component={DashBoard} />

      <Route path='/update-user' component={updateUser} />
      <Route path='/user-settings' component={UserSettings} />
      <Route path='/reports/users' component={usersReports} />
      <Route path='/reports/artisans' component={artisansReports} />
      <Route path='/reports/suppliers' component={suppliersReports} />
      <Route path='/reports/artisans-tags' component={artisansTagsReports} />
      <Route path='/reports/suppliers-tags' component={suppliersTagsReports} />
      <Route path='/jobs/artisan' component={ArtisanJobs} />
      <Route path='/jobs/company' component={companyJobs} />
      <Route path='/jobs/supplier' component={supplierJobs} />
      <Route path='/jobs/my-apply/' component={applicantsjobs} />
      <Route path='/jobs/recommendation/' component={RecArtisanJobsList} />
      <Route
        path='/reports/artisans-categories'
        component={artisansCategoriesReports}
      />
      <Route path='/create-profiles' component={FormEditIndex} />
      <Route
        path='/reports/suppliers-categories'
        component={suppliersCategoriesReports}
      />

      {/* <Route path="/training-center" component={TrainingCenter} /> */}

      <Redirect to={{ pathname: '/error/404' }} />
    </Switch>
  );
}

const mapStateToProps = state => {
  return {
    userData: authCurrentUserSelector(state),
    userType: authCurrentDefaultTypeSelecetor(state)
  };
};
export default connect(mapStateToProps)(HomePage);
